export default __webpack_public_path__ + "static/media/oracle-negative.0c1d734f.svg";